import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ReportDefinitionFormDto } from "../features/reportDefinition/types";

export interface ReportDefinitionState {
    data: ReportDefinitionFormDto;
    errors: {
        [key: string]: string | undefined;
    };
}

const initialState: ReportDefinitionState = {
    data: {
        id: 0,
        title: "",
        status: 0,
        executionMode: 0,
        contentDeliveryType: 0,
        frequencyType: null,
        isVisibleInService: false,
        isVisibleInOrganizationalStructure: false,
        isPeriodical: false,
        sendingDate: undefined,
        selectedKPIs: [],
        selectedUsers: [],
        selectedFunctionalAreas: [],
        selectedServiceIndicators: [],
        selectedRequestTypes: [],
        selectedOrganizationalStructures: []
    },
    errors: {}
};

const reportDefinitionSlice = createSlice({
    name: "reportDefinitionForm",
    initialState,
    reducers: {
        setForm(state, action: PayloadAction<Partial<ReportDefinitionFormDto>>) {
            Object.assign(state.data, action.payload);
        },
        setField(
            state,
            action: PayloadAction<{ field: keyof ReportDefinitionFormDto; value: ReportDefinitionFormDto[keyof ReportDefinitionFormDto] }>
        ) {
            const { field, value } = action.payload;
            state.data[field] = value as never;
        },
        setError(state, action: PayloadAction<{ field: keyof ReportDefinitionFormDto | string; message: string | undefined }>) {
            const { field, message } = action.payload;
            state.errors[field] = message;
        },
        setErrors(state, action: PayloadAction<{ [key: string]: string | undefined }>) {
            state.errors = action.payload;
        },
        clearErrors(state) {
            state.errors = {};
        },
        resetForm() {
            return initialState;
        }
    }
});

export const {
    setForm,
    setField,
    setError,
    setErrors,
    clearErrors,
    resetForm
} = reportDefinitionSlice.actions;

export default reportDefinitionSlice.reducer;
